export const ssoMode = {
  redirect: "redirect"
};
